module.exports = __webpack_public_path__ + "img/banner-after.b056e4c9.jpg";